export default {
    //动画函数
    animations(domTop, styleClassName, animation) {
        let scrollTop = document.documentElement.scrollTop; //获取滚动条滚动高度
        let clientHeight = document.documentElement.clientHeight; //获取当前屏幕的高度
        if (scrollTop-120 > domTop - clientHeight) {
            styleClassName.add(animation);
        }
    }
}